module.exports = __webpack_public_path__ + "img/register-your-pass.1c1ed5ca.svg";